import React from "react";
import '../components/Tile.css'; // Importálja a CSS fájlt

function Tile({ icon, text, onClick, disabled = false }) {
    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };
    
    return (
        <div className={`tile ${disabled ? 'tile-disabled' : ''}`} onClick={handleClick}>
            {icon}
            <p>{text}</p>
        </div>
    );
}

export default Tile;
